define([
    "underscore",
    "backbone"
], function(_, Backbone) {
    return Backbone.Model.extend({
        url: "/rest_account/save_contact_method",

        validation: {
            messenger_type: {
                required: false,
                maxLength: 128
            },
            messenger_id: {
                required: false,
                maxLength: 128
            }
        }
    });
});
